// CMP-0104 · LFS Public Layout Wrapper · Catalog Engine · Lot Discovery · owner: Platform
// 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
// 99-1-decision: ADAPT Spire's existing wrapper (archived at docs/archive/spire-inherited/public-layout-wrapper.tsx.txt) to place the Lot For Sale header, footer and the one shared inquiry popup; admin routes stay unwrapped
"use client"

import { usePathname } from "next/navigation"
import { LfsHeader } from "@/components/lfs/header"
import { LfsFooter } from "@/components/lfs/footer"
import { InquiryModal } from "@/components/lfs/inquiry-modal"
import type { NavData } from "@/lib/lfs/nav"

export function PublicLayoutWrapper({ children, nav }: { children: React.ReactNode; nav: NavData }) {
  const pathname = usePathname()
  if (pathname?.startsWith("/admin")) return <>{children}</>
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <LfsHeader nav={nav} />
      <main style={{ flex: 1 }}>{children}</main>
      <LfsFooter nav={nav} />
      <InquiryModal provinces={nav.provinces.map((p) => p.name)} />
    </div>
  )
}
